export default __webpack_public_path__ + "static/media/logo-card.306e7e1a.jpg";